import React from 'react';
import { stringify } from '../../util/urlHelpers';
import { NamedLink, IconClose } from '../index';
import classNames from 'classnames';
import css from './Topbar.css';
import { useSelector, useDispatch } from 'react-redux';
import { setPromoBarOpen, selectIsPromoBarOpen } from '../../ducks/UI.duck';

const PromoBar = () => {
  const isPromoBarOpen = useSelector(selectIsPromoBarOpen);
  const dispatch = useDispatch();
  const [promoBarIndex, setPromoBarIndex] = React.useState(0);
  const promoBarTimer = React.useRef(null);

  React.useEffect(() => {
    if (process.env.REACT_APP_COUNTRY_ID !== 'pl' || !isPromoBarOpen) return;
    // On mount: check localStorage and update Redux if needed
    const closedTimestamp = localStorage.getItem('promoBarClosedAt');
    if (closedTimestamp) {
      const now = Date.now();
      const diff = now - parseInt(closedTimestamp, 10);
      if (diff < 24 * 60 * 60 * 1000) {
        dispatch(setPromoBarOpen(false));
      }
    }
    promoBarTimer.current = setInterval(() => {
      setPromoBarIndex(idx => (idx + 1) % 2);
    }, 10000);
    return () => {
      if (promoBarTimer.current) clearInterval(promoBarTimer.current);
    };
  }, [dispatch]);

  const handleClosePromoBar = () => {
    dispatch(setPromoBarOpen(false));
    localStorage.setItem('promoBarClosedAt', Date.now().toString());
  };

  if (process.env.REACT_APP_COUNTRY_ID !== 'pl' || !isPromoBarOpen) return null;

  const bars = [
    {
      className: classNames(css.promoBar, css.promoBarBlue),
      text: (
        <>
          <strong>Jesienna promocja!</strong> Wypożycz rower na min. 3 dni i zyskaj <strong>-25%</strong> z kodem "<strong>ROWER25</strong>"
        </>
      ),
      linkName: 'SearchPage',
      pageParams: { keywords: 'rower'}
    },
    {
      className: classNames(css.promoBar, css.promoBarRed),
      text: (
        <>
          <strong>Letnia promocja!</strong> Wypożycz SUP-a na min. 2 dni i zyskaj <strong>-25%</strong> z kodem "<strong>WODA25</strong>"
        </>
      ),
      linkName: 'WatersportsSupSearchPage',
    }
  ];
  return (
    <div className={bars[promoBarIndex].className}>
      <div className={css.promoBarText}>
        <NamedLink className={css.promoBarLink} name={bars[promoBarIndex].linkName} to={{ search: stringify(bars[promoBarIndex].pageParams || {}) }}>
          {bars[promoBarIndex].text}
        </NamedLink>
      </div>
      <span className={css.promoBarClose} onClick={handleClosePromoBar}>
        <IconClose />
      </span>
    </div>
  );
};

export default PromoBar;